<template>
  <MyPrize />
</template>

<script>
import MyPrize from "place/drawactivity/MyPrize.vue";
export default {
  data() {
    return {};
  },
  components: {
    MyPrize,
  },
};
</script>
<style lang="" scoped></style>
